import React from 'react';
import { getTechIcon } from '../data/techIcons';

function StackBadges({ items }) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="stack-badges">
      {items.map((item) => {
        const iconSrc = getTechIcon(item);

        return (
          <span key={item} className="stack-badge">
            {iconSrc && (
              <img
                className="stack-badge-icon"
                src={iconSrc}
                alt=""
                width={14}
                height={14}
              />
            )}
            <span>{item}</span>
          </span>
        );
      })}
    </div>
  );
}

export default StackBadges;
